import { render, staticRenderFns } from "./chevron-up-icon.vue?vue&type=template&id=ca25e26a&functional=true&"
var script = {}
import style0 from "./svg-icon.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports